import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiNameList } from 'src/environments/api-name-list';
import { AppConfigService } from '../../main/app-config.service';
import { UserCacheService } from './user-cache.service';
@Injectable()
export class WcsApiService {

    private wcsUrl: any;
    private environment: any;
    constructor(private http: HttpClient, public userCacheService: UserCacheService, private appConfigService: AppConfigService) {
        this.environment = this.appConfigService.getConfig();
        //this.wcsUrl = "https://internal-ems-dev-ui-lb-1740877624.us-east-1.elb.amazonaws.com/" + environment.baseUrlOWCS; //Rewrite the baseUrl.
        this.wcsUrl = ApiNameList.restApi.baseUrl + this.environment.baseUrlWCS; //Rewrite the baseUrl.
    }

    /**
     * Method to fetch WCS template based on page route.
     * @param pageRoute 
     */
    getWcsContent(pageRoute: string) {
        // const locale = 'es_US';
        // if (environment.environment === 'local') {
        //     this.wcsUrl = ApiNameList.restApi.baseUrl + environment.baseUrlWCS + pageRoute;
        // } else {
        //     //const wcsPath = (locale === 'es_US') ? environment.baseUrlSpanishOWCS : environment.baseUrlOWCS;
        //     this.wcsUrl = ApiNameList.restApi.baseUrl + environment.baseUrlWCS + pageRoute;
        // }
        this.wcsUrl = ApiNameList.restApi.baseUrl + this.environment.baseUrlWCS + pageRoute;
        if (this.environment.environment === 'local') {
            this.wcsUrl = 'https://client.studentenroll.sit1-az.anthem.com/' + this.environment.baseUrlWCS + pageRoute;
        }
        return this.http.get(this.wcsUrl, { responseType: 'text' })
    }
}